import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {SCREEN_NAMES} from '/enum/tealium.enum';
import {
  addCoachToWatchlist,
  getCoachWatchlist,
  getViewTeams,
  removeCoachFromWatchlist,
  resetMyTeamsInfo,
  resetViewTeamsInfo,
} from '/redux/action/myTeams.action';
import {MyteamsReduxKeys, resetReport} from '/redux/action/report.action';
import {
  highestAchievedRankDescriptionById,
  paidAsRankDescLastMonth,
  rankDescriptionById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {
  downlineCoachIds,
  watchlistCount,
} from '/redux/selector/watchList.selector';
import {withScreenPersistence} from '/util/async-storage';
import {withProps} from '/util/selector.util';

import {MyTeamsContent} from './MyTeamsContent';

const MyTeamsContentConnected = connect(
  createStructuredSelector({
    userId,
    featureFlag: variablesFeatureFlag,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    highestAchievedRank: withProps({coachId: userId})(
      highestAchievedRankDescriptionById,
    ),
    coachCurrentRank: withProps({coachId: userId})(rankDescriptionById),
    downlineCoachIds,
    count: watchlistCount,
  }),

  dispatch => ({
    getViewTeams: ({
      coachId,
      pageNumber,
      reportName,
      reportParams,
      ...filtersData
    }: any) =>
      dispatch<any>(
        getViewTeams({
          coachId,
          pageNumber,
          reportName,
          reportParams: reportParams ?? [filtersData],
        }),
      ),

    // Watchlist dispatch
    addCoachToWatchlist: (downlineCoachId: string) =>
      dispatch<any>(addCoachToWatchlist({downlineCoachId})),
    removeCoachFromWatchlist: (downlineCoachId: string) =>
      dispatch<any>(removeCoachFromWatchlist({downlineCoachId})),
    getCoachWatchlist: () => dispatch<any>(getCoachWatchlist()),
    resetReport: ({reportKey}: any) =>
      dispatch<any>(resetReport({reportKey, data: null})),
    resetMyTeamsInfo: () =>
      dispatch<any>(resetMyTeamsInfo({inputPayload: null})),
    resetViewTeamsInfo: () =>
      dispatch<any>(resetViewTeamsInfo({inputPayload: null})),
  }),

  (stateProps, dispatchProps, ownProps) => {
    const {recordId, coachId, pageNumber, reportName, filtersData} = ownProps;
    const effectiveCoachId = coachId || recordId;

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fetchData: () => {
        return dispatchProps.getViewTeams({
          coachId: effectiveCoachId,
          pageNumber,
          reportName,
          reportParams: [filtersData],
        });
      },

      resetMyTeamsData: () => {
        dispatchProps.resetMyTeamsInfo();
        MyteamsReduxKeys.forEach(element => {
          dispatchProps.resetReport({
            reportKey: element,
          });
        });
      },
      resetViewTeamsData: () => {
        dispatchProps.resetViewTeamsInfo();
        MyteamsReduxKeys.forEach(element => {
          dispatchProps.resetReport({
            reportKey: element,
          });
        });
      },
    };
  },
)(MyTeamsContent);

export default withScreenPersistence(
  MyTeamsContentConnected,
  SCREEN_NAMES.myTeamsReport,
);
